import { render, staticRenderFns } from "./ListItemRules.vue?vue&type=template&id=678d2f22&scoped=true&"
import script from "./ListItemRules.vue?vue&type=script&lang=ts&"
export * from "./ListItemRules.vue?vue&type=script&lang=ts&"
import style0 from "./ListItemRules.vue?vue&type=style&index=0&id=678d2f22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678d2f22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
